import React, { Component } from 'react';
import Header from '../../Components/Header/';
import Table from '../Table/';
import LoaderScreen from '../../Components/LoaderScreen/';
import WorkoutDescription from '../../Components/WorkoutDescription/';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import './App.css';


const theme = createMuiTheme({
  overrides: {
    // Name of the component ⚛️ / style sheet
    MuiButton: {
      // Name of the rule
      outlined: {
        // Some CSS
        background: '#E8E8E8;',
        border: '1px solid rgba(0, 0, 0, 0);'
      },
    },
    MuiDialog: {
      paper: {
        '@media (max-width: 600px)': {
          margin: '48px 42px !important'
        }
      }
    }
  },
  typography: { useNextVariants: true }
});

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      name: '',
      getUrlLocation: '',
      currentList: [],
      fakeIdx: true,
      currentPageNumber: 0,
      leaderboardId: 274,
      backupLeaderboardId: 1,
      lastPageNumber: 10,
      divisionId: process.env.REACT_APP_DIVISION_ROOT,
      backupDivisionId: process.env.REACT_APP_DIVISION_SECONDARY,
      eventConfig: {},
      activeEventId: -1,
      reverse: false,
      hideHeader: false,
      hideWorkoutDescription: true
    }

    this.updateName = this.updateName.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.getPage = this.getPage.bind(this);
    this.getLeaderboard = this.getLeaderboard.bind(this);
    this.getLeaderboardWithPage = this.getLeaderboardWithPage
    this.updateScrollTo = this.updateScrollTo.bind(this);
    this.switchLeaderboards = this.switchLeaderboards.bind(this);
    this.getEventPage = this.getEventPage.bind(this);
    this.toggleWorkoutDescription = this.toggleWorkoutDescription.bind(this);
  }

  componentDidMount() {
    this.getLeaderboard(true);
    if(window.location.search) {
      let getRidOfHeader = window.location.search.split('?header=');
      if(getRidOfHeader[1]) this.setState({
        hideHeader: getRidOfHeader[1]
      });
    }
  }

  updateName(name) {
    this.setState({
      name: name.toString()
    });
  }

  getPage(number, leaderboard, scrollTo, init) {

    let catchNumber = number ? number : 0;
    const catchLeaderboard = leaderboard ? leaderboard : this.state.leaderboardId;
    let reverse = false;

    if(catchLeaderboard === this.state.leaderboardId && this.state.currentPageNumber === catchNumber && init !== true && !scrollTo && !this.state.eventSorting) {
      reverse = !this.state.reverse;
      catchNumber = this.state.lastPageNumber;
    }

    this.setState({
      loading: true
    });

    let urlToGet = 'https://us-central1-btwb-thewire.cloudfunctions.net/' + process.env.REACT_APP_API_PREFIX + 'LeaderboardPages?leaderboard_id=' + catchLeaderboard + '&page=' + catchNumber;

    return fetch(urlToGet, {

    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      this.setState({
        currentList: (reverse ? data.Standings.reverse() : data.Standings),
        currentPageNumber: catchNumber,
        loading: false,
        reverse: reverse,
        eventSorting: false,
        activeEventId: -1
      }, () => {
        if(scrollTo) {
          this.updateScrollTo(scrollTo);
        } else {
          this.setState({scrollTo: undefined})
        }
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });
  }

  // get SPECIFIC EVENT leaderboards
  getEventPage(eventId, page) {
    let reverse = false;
    
    if(eventId === this.state.activeEventId && this.state.currentPageNumber === page) reverse = !this.state.reverse;
    
    this.setState({
      loading: true,
      eventSorting: true,
      activeEventId: eventId ? eventId : this.state.activeEventId,
      reverse: reverse
    });

    let lastpg = this.state.lastPageNumber;

    if(this.state.lastPageNumber === 0) lastpg = 1;

    return fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + 
      process.env.REACT_APP_API_PREFIX + 'LeaderboardPagesByEvent?leaderboard_id='+ 
      this.state.leaderboardId +'&event_id=' + (eventId ? eventId : this.state.activeEventId) + '&page=' + (reverse ? lastpg - 1 : page)).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      return this.setState({
        currentList: (reverse ? data.Standings.reverse() : data.Standings),
        currentPageNumber: page,
        loading: false
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });
  }

  getLeaderboard(init, eventIdToGet, pointsHack) {
    let activeEventId = pointsHack ? -1 : this.state.activeEventId;

    this.setState({
      loading: true,
      // eventSorting: pointsHack ? false : this.state.eventSorting,
      activeEventId: activeEventId
    });

    // if(this.state.divisionId === '3') {
    //   return this.setState({
    //     backupLeaderboardId: 1137,
    //     leaderboardId: 881,
    //     lastPageNumber: 7,
    //     eventConfig: {"division_id":3,"event_ids":[19,21,23,25],"output_spanner":true}
    //   }, () => {
    //     console.log('we are static')
    //     if(!pointsHack && this.state.eventSorting) return this.getEventPage(this.state.eventConfig.event_ids[eventIdToGet], 0);
    //     return this.getPage(0, undefined, undefined, (pointsHack && activeEventId !== -1 ? true : init));
    //   })
    // } else if(this.state.divisionId === '4') {
    //   return this.setState({
    //     backupLeaderboardId: 881,
    //     leaderboardId: 1137,
    //     lastPageNumber: 1,
    //     eventConfig: {"division_id":4,"event_ids":[20,22,24,26],"output_spanner":true}
    //   }, () => {
    //     console.log('we are static too')
    //     if(!pointsHack && this.state.eventSorting) return this.getEventPage(this.state.eventConfig.event_ids[eventIdToGet], 0);
    //     return this.getPage(0, undefined, undefined, (pointsHack && activeEventId !== -1 ? true : init));
    //   })
    // }

    fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + process.env.REACT_APP_API_PREFIX + 'Leaderboards?division_id=' + this.state.backupDivisionId, {
    }).then(res => {
      if(!res.ok){
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      this.setState({
        backupLeaderboardId: data.LeaderboardId
      });
    }).catch(err => {
      console.log(err)
      this.setState({
        loading: false
      })
    })

    return fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + process.env.REACT_APP_API_PREFIX + 'Leaderboards?division_id=' + this.state.divisionId, {

    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data =>{
      if(pointsHack) {
        window.scrollTo(0, 0);
      }
      this.setState({
        leaderboardId: data.LeaderboardId,
        lastPageNumber: data.Pages - 1,
        eventConfig: JSON.parse(data.Config)
      }, () => {
        if(!pointsHack && this.state.eventSorting) return this.getEventPage(this.state.eventConfig.event_ids[eventIdToGet], 0);
        return this.getPage(0, undefined, undefined, (pointsHack && activeEventId !== -1 ? true : init));
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });

  }

  // emrgency
  getLeaderboardWithPage(page, scrollTo) {

    this.setState({
      loading: true,
      // eventSorting: pointsHack ? false : this.state.eventSorting,
      activeEventId: -1
    });



    // if(this.state.divisionId === '3') {
    //   return this.setState({
    //     backupLeaderboardId: 1137,
    //     leaderboardId: 881,
    //     lastPageNumber: 7,
    //     eventConfig: {"division_id":3,"event_ids":[19,21,23,25],"output_spanner":true}
    //   }, () => {
    //     return this.getPage(page, undefined, scrollTo, true);
    //   })
    // } else if(this.state.divisionId === '4') {
    //   return this.setState({
    //     backupLeaderboardId: 881,
    //     leaderboardId: 1137,
    //     lastPageNumber: 1,
    //     eventConfig: {"division_id":4,"event_ids":[20,22,24,26],"output_spanner":true}
    //   }, () => {
    //     return this.getPage(page, undefined, scrollTo, true);
    //   })
    // }

    fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + process.env.REACT_APP_API_PREFIX + 'Leaderboards?division_id=' + this.state.backupDivisionId, {
    }).then(res => {
      if(!res.ok){
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      this.setState({
        backupLeaderboardId: data.LeaderboardId
      });
    }).catch(err => {
      console.log(err)
      this.setState({
        loading: false
      })
    })

    return fetch('https://us-central1-btwb-thewire.cloudfunctions.net/' + process.env.REACT_APP_API_PREFIX + 'Leaderboards?division_id=' + this.state.divisionId, {

    }).then(res => {
      if(!res.ok) {
        throw Error(res.statusText);
      }
      return res.json();
    }).then(data => {
      this.setState({
        leaderboardId: data.LeaderboardId,
        lastPageNumber: data.Pages - 1,
        eventConfig: JSON.parse(data.Config)
      }, () => {
        return this.getPage(page, undefined, scrollTo, true);
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        loading: false
      })
    });
  }

  updateScrollTo(val) {
    this.setState({
      scrollTo: parseInt(val)
    }, () => {
      this.setState({scrollTo: undefined});
    })
  }

  updatePage(page, emptyVal, scrollTo, leaderboard, divisionId) {
    // I hate this
    let getLeaderboardInstead = false;

    let leaderboardId = leaderboard ? leaderboard : this.state.leaderboardId;
    let backupLeaderboardId = leaderboard ? (
      leaderboard === this.state.leaderboardId ? this.state.backupLeaderboardId : this.state.leaderboardId
    ) : this.state.backupLeaderboardId;

    let letActualPage = page ? page : 0;
    if(backupLeaderboardId !== this.state.backupLeaderboardId) getLeaderboardInstead = true;
    this.setState({
      // hack, if passing through a leaderboard then it has to be coming from search
      eventSorting: leaderboard ? false : this.state.eventSorting,
      leaderboardId: leaderboardId,
      backupLeaderboardId: backupLeaderboardId,
      divisionId: divisionId ? divisionId.toString() : this.state.divisionId,
      backupDivisionId: divisionId ? (divisionId === this.state.divisionId ? this.state.backupDivisionId : this.state.divisionId) : this.state.backupDivisionId
    }, () => {
      
      if(getLeaderboardInstead) {
        return this.getLeaderboardWithPage(page, scrollTo);
      }

      if(this.state.eventSorting) {
        this.getEventPage(this.state.eventId, letActualPage); 
      } else {
        this.getPage(letActualPage, this.state.leaderboardId, scrollTo); 
      }
    });
  }

  switchLeaderboards(divisionId, backupDivisionId) {
    if(this.state.divisionId === divisionId) return;

    const eventIdToGet = this.state.eventConfig.event_ids.indexOf(this.state.activeEventId)
    this.setState({
      divisionId: divisionId,
      backupDivisionId: backupDivisionId
    }, () => {
      return this.getLeaderboard(true, eventIdToGet);
    })
  }

  handleAutoSuggestChange(name, eventName) {
    let member = this.state.member;
    member.gym = eventName;
    this.setState({member: member})
  }

  toggleWorkoutDescription() {
    let currentState = this.state.hideWorkoutDescription;

    this.setState({
      hideWorkoutDescription: !currentState
    })
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header 
            currentName={this.state.name}
            updateName={this.updateName}
            updatePage={this.updatePage}
            onSelect={this.updatePage}
            leaderboardId={this.state.leaderboardId}
            backupLeaderboardId={this.state.backupLeaderboardId}
            hideHeader={this.state.hideHeader}
            toggleWorkoutDescription={this.toggleWorkoutDescription}
            hideWorkoutDescription={this.state.hideWorkoutDescription}
          />
          {(!this.state.hideHeader && !this.state.hideWorkoutDescription) &&
            <WorkoutDescription />
          }
          <Table
            data={this.state.currentList ? this.state.currentList : []}
            loading={this.state.loading}
            updatePage={this.updatePage}
            currentPageNumber={this.state.currentPageNumber}
            leaderboardId={this.state.leaderboardId}
            lastPageNumber={this.state.lastPageNumber}
            scrollTo={this.state.scrollTo}
            eventConfig={this.state.eventConfig}
            getEventPage={this.getEventPage}
            getLeaderboard={this.getLeaderboard}
            activeEventId={this.state.activeEventId}
            reverse={this.state.reverse}
            divisionId={this.state.divisionId}
            switchLeaderboards={this.switchLeaderboards}
            getPage={this.getPage}
          />
          <LoaderScreen
            loading={this.state.loading}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;
